module.exports = __webpack_public_path__ + "img/3.555d7371.png";